import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { CustomCheckoutService } from '@checkout/feature';
import { CustomOrder } from '@order/const';
import { OnlineOrderService } from '@order/feature';
import { Observable } from 'rxjs';
import { filter, startWith, switchMap } from 'rxjs/operators';

@Component({
  selector: 'sd-order-confirmation-info-invoice-button',
  templateUrl: './order-confirmation-info-invoice-button.component.html',
  styleUrls: ['./order-confirmation-info-invoice-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SdvorOrderConfirmationInfoInvoiceButtonComponent implements OnInit {
  order$: Observable<CustomOrder>;
  loading$: Observable<boolean>;

  constructor(
    private customCheckoutService: CustomCheckoutService,
    private onlineOrderService: OnlineOrderService,
  ) {}

  ngOnInit(): void {
    this.order$ = this.customCheckoutService
      .getOrderDetails()
      .pipe(filter<CustomOrder>((order) => Object.keys(order || {}).length > 0));

    this.loading$ = this.order$.pipe(
      switchMap((order) => this.onlineOrderService.getOrderInvoicePaymentLoading(order.guid)),
      startWith(false),
    );
  }

  onClickButtonBill(order: CustomOrder): void {
    this.onlineOrderService.downloadOrderInvoicePayment(order.guid, order.code);
  }
}
